import noSpecialChars from '../../../form/field-validation/noSpecialChars';

export default {
  postcode: noSpecialChars('postcode'),
};
